import { useEffect } from 'react';

const WineModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center transition-all p-4 bg-black bg-opacity-50"
    >
      <div
        className="flex flex-col items-center justify-center relative w-full max-w-md"
        onClick={e => e.stopPropagation()}
      >
        <div className="w-full flex flex-col justify-center">
          <div className="relative bg-white p-4 md:p-6 rounded-lg shadow-md mb-4">
            <div className="text-black text-center">
              <div className="mb-4">
                <img 
                  src="/img/goty2024/game-wine.png" 
                  alt="酒瓶" 
                  className="w-16 h-16 mx-auto mb-3 object-contain"
                />
                <h3 className="text-lg md:text-xl font-bold mb-2">你撿到了一個酒瓶！</h3>
                <p className="text-sm md:text-base">
                  來看影展的人太嗨了吧，居然自備酒水！<br/>
                  但為什麼藏在草叢裡？你覺得可能有人會需要這個 ...
                </p>
              </div>
            </div>
          </div>
          <div className="w-full">
            <button
              onClick={onClose}
              className="w-full p-3 md:p-4 text-center border-2 border-[#7B2337] rounded-lg transition-all duration-300 bg-white text-[#7B2337] hover:bg-[#7B2337] hover:text-white font-bold"
            >
              先收起來
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WineModal; 